
import HomeCmp from '../components/HomeCmp.js';

const { connect } = require('react-redux');

const { logout, checkToken  } = require('../actions/loginAction')
const { emitir } = require('../actions/homeAction')

const mapStateToProps = (state) => {
    return{
      emision: state.homeReducer.respuesta,
      status: state.loginReducer.status
    }
};

const mapDispatchToProps = dispatch => ({
  checkToken: () => {
    dispatch(checkToken());
  },
  emitir: (payload) => {
    dispatch(emitir(payload));
  },
  logout: () => {
    dispatch(logout());
  }
 });

export default connect(mapStateToProps, mapDispatchToProps)(HomeCmp);
